import { AreaInfo } from 'ais-facade-api/api';

export const sortAreas = (areas: AreaInfo[], type: string) => {
  return areas
    .filter((area) => area.type === type)
    .sort(({ name: nameA = '' }, { name: nameB = '' }) => nameA.localeCompare(nameB));
};
